import approve0 from "../../assets/images/rule/approve-0.svg";
import approve1 from "../../assets/images/rule/approve-1.svg";
import approve2 from "../../assets/images/rule/approve-2.svg";
import approve3 from "../../assets/images/rule/approve-3.svg";
import approve5 from "../../assets/images/rule/approve-5.svg";

import styles from "./index.module.scss";

export default function PrivacyIcons() {
  const images = [approve2, approve0, approve1, approve3, approve5];
  return (
    <div className={styles["privacy-icons"]}>
      {images.map((src) => (
        <img src={src} key={src} alt=""></img>
      ))}
    </div>
  );
}
